const replaceArrayItem = (array, idx, updater) => {
  return array
    .slice(0, idx)
    .concat(updater(array[idx]))
    .concat(array.slice(idx + 1));
};

export default replaceArrayItem;
